<template>
  <div
    v-check-visible-viewport="onVisibleInViewport"
    v-if="podcast"
    ref="show-card"
    :data-segment-uuid="podcast.uuid"
    class="show-card"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut"
    @click="onPodcastClicked">
    <div class="card-image">
      <div :class="`image-overlay ${hovered ? 'visible' : ''}`">
        <picture-component
          :src="podcast.display_image_url || podcast.image_url"
        />
        <span
          v-if="isLatestEpisode && hovered"
          class="counter"
        >
          New Episode
        </span>
      </div>
      <picture-component
        :src="podcast.display_image_url || podcast.image_url"
      />
    </div>
    <div :class="`card-content${podcast.is_exclusive ? ' is-exclusive' : ''}`">
      <PremiumIndicator v-if="podcast.is_exclusive" />
      <p
        data-test="header"
        class="header">{{ podcast.title | truncate(25) }}</p>
      <p
        v-if="latestEpisode"
        class="date">{{ latestEpisode.released_at | podcastDateFilter }}
      </p>
      <div :class="`text-overlay ${hovered ? 'visible' : ''}`">
        <PremiumIndicator v-if="podcast.is_exclusive" />
        <p>{{ podcast.title }}</p>
        <div v-if="latestEpisode && latestEpisode.uuid">
          <p>{{ latestEpisode.title }}</p>
          <p class="latest-episode">Latest Episode</p>

          <img
            v-if="!isPlaying && !isLoading"
            data-test="play-latest-episode"
            src="../assets/images/btn_play_base.svg"
            @click="playEpisode"
          >
          <div
            v-if="isLoading"
            class="loading-icon">
            <i class="el-icon-loading text-blue"/>
          </div>
          <img
            v-if="isPlaying && !isLoading"
            class="pause"
            src="../assets/images/ic_pause_blue.svg"
            @click="pauseEpisode"
          >
        </div>
      </div>
    </div>
    <span
      v-if="isLatestEpisode && !hovered"
      class="counter"
    >
      New Episode
    </span>
  </div>
</template>
<script>
import placeholder from '../assets/images/placeholder1.jpg';
import PremiumIndicator from './PremiumIndicator';

export default {
  name: 'ShowCard',
  components: {
    PremiumIndicator,
  },
  props: {
    podcast: {
      type: Object,
      default: () => {},
    },
    lastViewedAt: {
      type: String,
      default: '',
    },
    latestEpisode: {
      type: Object,
      default: () => {},
    },
    episodeCount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      placeholder,
      hovered: false,
    };
  },
  computed: {
    isPlaying() {
      const currentlyPlayingEpisode = this.$store.getters.episode;
      const playing = this.$store.getters.play;

      return this.latestEpisode && playing && (currentlyPlayingEpisode && (currentlyPlayingEpisode.uuid === this.latestEpisode.uuid));
    },
    isLoading() {
      const { status, episode } = this.$store.getters;

      return this.latestEpisode && status === 'loading' && episode && (episode.uuid === this.latestEpisode.uuid);
    },
    isLatestEpisode() {
      return this.latestEpisode && this.podcast ? new Date(this.latestEpisode.released_at) > new Date(this.lastViewedAt) : false;
    },
  },
  methods: {
    playEpisode(event) {
      event.stopPropagation();

      // this.loadMediaInPlayer(this.latestEpisode.media_url);

      this.loadMediaInPlayer(this.latestEpisode.media_url, this.latestEpisode.is_exclusive);
      const { episode } = this.$store.getters;
      if (this.latestEpisode && this.latestEpisode.uuid === episode.uuid) {
        this.$store.dispatch('play');
      } else {
        this.$store.dispatch('setAndPlayEpisode', this.latestEpisode);
      }
    },
    pauseEpisode(event) {
      event.stopPropagation();

      this.$store.dispatch('pause');
    },
    onPodcastClicked() {
      this.$emit('podcastClicked');
      this.$router.push(`/listen/${this.podcast.publisher.slug}/${this.podcast.slug}/${this.podcast.uuid}`);
    },
    onMouseOver() {
      this.hovered = true;
    },
    onMouseOut() {
      this.hovered = false;
    },
    onVisibleInViewport() {
      const ele = this.$refs['show-card'];
      if (ele) {
        ele.classList.add('is-visible');
      }
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";
  .show-card {
    display: block;
    position: relative;
    background-color: #fff !important;
    margin: 0 .5rem 3rem .5rem;
    z-index: 998;
    cursor: pointer;

    &:hover {
      z-index: 1000;
    }

    .card-image {
      // max-width: 288px;
      // min-height: 288px;
      // height: 100%;
      position: relative;
      > img {
        border: 1px solid #eee;
      }
    }
    .card-content {
      margin-top: 1rem;
      position: relative;

      &.is-exclusive {
        margin-top: 0;
      }

      .premium-indicator {
        margin: 0 0 8px !important;
      }

      .date {
        color: $light-gray2;
        font-weight: lighter;
        margin-top:.2rem;
      }
      .header {
        font-size: 14px;
        margin:0 !important;
        color: $black;
      }
      .publisher {
        color: $light-gray;
      }
    }
    .counter {
      display: inline-block;
      font-size: 11px;
      background-color: rgba(17,17,17,0.8);
      color: #fff;
      line-height: 13px;
      position: absolute;
      top: 7px;
      left: 8px;
      padding: 2px 4px;
      border-radius: 1px;
    }

    .image-overlay {
      position: absolute;

      height: 100%;
      width: 100%;

      top: -6px;
      left: 0;

      opacity: 0;

      transform-origin: 50% 100%;
      transition: 100ms;

      box-sizing: border-box;

      &.visible {
        transform: scaleX(1.125) scaleY(1.1);

        box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);

        opacity: 1;
      }
    }

    .card-content.is-exclusive .text-overlay {
      margin-top: 1rem;
    }

    .text-overlay {
      position: absolute;

      padding: 15px 16px;
      width: 100%;

      top: calc(-1rem - 6px);
      left: 0;

      opacity: 0;

      transform-origin: 50% 0%;
      transition: 100ms;

      background-color: white;

      box-shadow: 0;

      box-sizing: border-box;

      p:not(.premium-indicator) {
        text-align: left;
        margin:0 !important;
        font-size: 16px;
        font-weight: 500;
        color: $black;

        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &.latest-episode {
          font-size: 14px;
          color: $gray;
        }
      }

      img, .loading-icon {
        position: absolute;

        top: 50%;
        right: 10px;

        transform: translateY(-50%);

        width: 26px;
        height: 26px;

        &.pause {
          width: 18px;
          height: 18px;
        }
      }

      > div {
        margin-top: 6px;
        width: 80%;
      }

      &.visible {
        transform: scaleX(1.125) scaleY(1.125);

        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);

        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// app/src/components/ShowCard.vue